export const DURATION = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 7000,
};
